import { makeStyles } from '@mui/styles';
import { colors } from '../../../colors';

export const useStyles = makeStyles(() => ({
  icon: {
    width: '16px',
    height: '20px',
  },
  sentIcon: {
    width: '19.46px',
    height: '21.31px',
  },
  badge: {
    fontWeight: `600 !important`,
  },
}));

export const sxStyles = {
  cardShadow: {
    boxShadow: '0px 0px 1px 0px #0000000A, 0px 0px 2px 0px #0000000F, 0px 4px 8px 0px #0000000A',
  },
  name: {
    fontSize: '18px !important',
    lineHeight: '24px !important',
  },
  status: {
    fontSize: '16px !important',
  },
  cardBorder: currentImportanceLevel => ({
    ...(currentImportanceLevel === 'DISCONTINUED' && {
      border: `1px solid ${colors.destructive600}`,
    }),
  }),
  outlineBtn: color => ({
    padding: '0px 12px !important',
    height: '36px !important',
    borderColor: color ? `${colors.primary600}!important` : `${colors.destructive600} !important`,
    '&:hover': {
      backgroundColor: color ? `${colors.primary50}!important` : `${colors.destructive50} !important`,
    },
    borderRadius: '6px !important',
  }),
  sigLineHeight: {
    lineHeight: '20px !important',
  },
};
